/**
 * SpineRenderer — placeholder for Spine skeletal animation objects.
 *
 * Full Spine rendering requires integration with SpineOffscreenRenderer
 * and the @esotericsoftware/spine-pixi-v8 runtime, which is complex.
 * This stub renders a colored rectangle with a "Spine" label so that
 * Spine objects are visible in the editor scene view.
 *
 * TODO: Replace with real Spine rendering once SpineOffscreenRenderer
 * integration is complete (Phase 3b or later).
 */
import { Container, Graphics, Text, TextStyle } from 'pixi.js';
import type { GameObject } from '@core/types/gameobject.types';

export class SpineRenderer {
  /** Create a placeholder container for a Spine game object. */
  static create(_gameObject: GameObject): Container {
    const container = new Container();

    // Purple-tinted placeholder rectangle
    const g = new Graphics();
    g.rect(-50, -50, 100, 100);
    g.fill({ color: 0x7c3aed, alpha: 0.3 });
    g.stroke({ color: 0x7c3aed, alpha: 0.6, width: 1 });

    const label = new Text({
      text: 'Spine',
      style: new TextStyle({
        fontFamily: 'Inter, sans-serif',
        fontSize: 12,
        fill: '#a78bfa',
      }),
    });
    label.anchor.set(0.5, 0.5);

    container.addChild(g);
    container.addChild(label);
    return container;
  }
}
